<template>
    <ui-crud title="Fines &amp; Charges" subtitle="A list of fines and charges."
             :fetch="fetch" :pipe-with="pipeItems">

        <!-- Filters. -->
        <template #filters>
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="`${item.pcn_number} - ${item.formatted_date}`"
                :subtitle="`${item.vehicle_name?item.vehicle_name:'--Unknown--'}`"
                :metadata="`${item.driver_name?item.driver_name:'--Unknown--'}`"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <fines-form :add-item="addItem" :vehicles="vehicles"></fines-form>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode }">
            <fines-form :item="selectedItem" :vehicles="vehicles" :edit="setEditMode"></fines-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem, addItem }">
            <fines-show :item="selectedItem" :edit="setEditMode" :removeItem="removeItem" :add-item="addItem"></fines-show>
        </template>
    </ui-crud>
</template>

<script>
import {Fine} from '@models'
import {Vehicle} from '@models';
import FinesForm from "./FinesForm.vue";
import UiCrud from "../ui/UiCrud.vue";
import UiInput from "../ui/UiInput.vue";
import UiCrudCard from "../ui/UiCrudCard.vue";


export default {
    components: {UiCrudCard, UiInput, UiCrud, FinesForm},
    props: {
        admin: Boolean,
    },
    data() {
        return {
            search: '',
            vehicles: [],
        }
    },
    methods: {
        async fetch() {
            return await Fine.all({})
        },
        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            if (query.length) {
                return items.filter((fine) => {
                    return query.every((token) => {
                        return fine.tokens.includes(token);
                    })
                });
            }
            return items;
        },
    },
    async mounted () {
        this.vehicles = (await Vehicle.all()).map(x => x.toDropdown())
    }
}
</script>
